$(document).ready(function() {
	if(!document.querySelector('.C0013')) return false;

	var $obj=$('.C0013');
	
	//change text
	$obj.find('.btn-tech-ctrl').click(function(){
		var $specArea = $(this).parent().next('.tech-spacs-area');
		$specArea.collapse('toggle');
		
		return false;
	});

	$obj.find('.tech-spacs-wrap').on({
		'show.bs.collapse': function(e){
			var btn = e.delegateTarget.querySelector('.btn-tech-ctrl');
			$(btn).removeClass('collapsed');
			$(btn).text(btn.getAttribute('data-close-title'));
			/* PJTWAUS-1 : 20191203  add */
			$(btn).attr('aria-expanded', true);
			/*// PJTWAUS-1 : 20191203 add */
		},
		'hide.bs.collapse': function(e){
			var btn = e.delegateTarget.querySelector('.btn-tech-ctrl');
			$(btn).addClass('collapsed');
			$(btn).text(btn.getAttribute('data-open-title'));
			/* PJTWAUS-1 : 20191203 add */
			$(btn).attr('aria-expanded', null); //LGEUS-519 한쪽 aria-expanded 삭제
			/*// PJTWAUS-1 : 20191203 add */
		}
	}, '.tech-spacs-area');
	
	var specRunPrint;
	specRunPrint= function(){
		if(!document.querySelector('.page-print') && !document.querySelector('.page-print')) return false;
		var $printPage = $obj.find('.page-print');
		//var p = window.location.protocol;
		//var host = window.location.hostname;
		//var port = window.location.port;
		//var mydomain = p + '//' + host + ((port)? ':'+port : '');
		$printPage.off().on('click', function(e) {
			e.preventDefault();
			// adobe
			adobeTrackEvent('print-spec', {page_event : {print_spec : true}});
			var modal = $(e.currentTarget).parents('.component-wrap').parent().get(0);
			if(modal) {
				//console.log('1');
				var divToPrint=modal;
				var newWin=window.open('','Print-Window');
				newWin.document.open();
				newWin.document.write('<html><body><link href="/lg5-common/css/fonts.min.css" type="text/css" rel="stylesheet"><link href="/lg5-common/css/default.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="/lg5-common/css/components.min.css" type="text/css" /><link href="/lg5-common/css/C0013.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="/lg5-common/css/modal-print.min.css" type="text/css" /><div class="specs-print">'+divToPrint.innerHTML+'</div><script src="/lg5-common/library/jquery.min.js" ></script><script>if($("img.lazyload").length>0) {$("img.lazyload").each(function() {$(this).attr("src", $(this).data("src")).removeClass("lazyload").addClass("lazyloaded");});}setTimeout(function() {window.print();}, 100);</script></body></html>');
				// newWin.document.write('<html><body><link href="'+mydomain+'/lg5-common/css/fonts.min.css" type="text/css" rel="stylesheet"><link href="'+mydomain+'/lg5-common/css/default.min.css" type="text/css" rel="stylesheet"><link rel="stylesheet" href="'+mydomain+'/lg5-common/css/components.min.css" type="text/css" /><link rel="stylesheet" href="'+mydomain+'/lg5-common/css/modal-print.min.css" type="text/css" /><div class="specs-print">'+divToPrint.innerHTML+'</div><script src="'+mydomain+'/lg5-common/library/jquery.min.js" ></script><script>if($("img.lazyload").length>0) {$("img.lazyload").each(function() {$(this).attr("src", $(this).data("src")).removeClass("lazyload").addClass("lazyloaded");});}setTimeout(function() {window.print();}, 100);</script></body></html>');
				setTimeout(function() {
					newWin.document.close();
					setTimeout(function(){newWin.close();},10);
				}, 200);
			}else {
				window.print();
			}
		});
	};
	specRunPrint();

	//$obj.find('.tech-spacs-area').removeClass('show');

	// adobe
	$('body').on('click', '.C0013 .pdp-specs-content .pdp-specs-output .download-spec', function() {
		adobeTrackEvent('download_spec_sheet', {page_event : {download_spec_sheet : true}});
	});
	$('body').on('click', '.C0013 .pdp-specs-content .pdp-specs-output .download-guide', function() {
		adobeTrackEvent('download_energy_guide', {page_event : {download_energy_guide : true}});
	});
});